import gql from 'graphql-tag';

const STATE_SORT_OPTIONS_QUERY = gql`
  query stateSortOptions {
    stateSortOptions
  }
`;

export default STATE_SORT_OPTIONS_QUERY;
